import { FC } from 'react';

import { APTypography } from '@astropay/web-core-library';
import { Box } from '@material-ui/core';

import ApImage from 'common/components/ap-image/ap-image';
import TimerToRedirect from 'common/components/time-to-redirect/time-to-redirect';
import { URL_RESOURCES } from 'common/config/constants/urls';
import { translate } from 'common/config/i18n';
import { useAppSelector } from 'common/helpers/hooks';
import { getMerchant } from 'common/store/deposit';

import { GenericErrorStyles } from './style';

export const GenericError: FC = () => {
  const classes = GenericErrorStyles();

  const merchant = useAppSelector(getMerchant);
  return (
    <Box
      className={classes.root}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      my={1}
      width="100%"
    >
      <ApImage sizes="small" src={`${URL_RESOURCES.globals}error.png`} alt="error" />
      <Box className={classes.errorSubtitleContainer}>
        <APTypography className={classes.errorSubtitle} textStyle="Typography_Poppins_18px_Bold">
          {translate('deposit_generic_error')}
        </APTypography>
      </Box>

      <Box className={classes.redirectContainer}>
        <TimerToRedirect merchantName={merchant?.name} url={merchant?.url} />
      </Box>
    </Box>
  );
};
